module.exports = __webpack_public_path__ + "img/bodycheck1.c52f7305.png";